import { render, staticRenderFns } from "./ClientTableList.vue?vue&type=template&id=64ce1e52&scoped=true&"
import script from "./ClientTableList.vue?vue&type=script&lang=js&"
export * from "./ClientTableList.vue?vue&type=script&lang=js&"
import style0 from "./ClientTableList.vue?vue&type=style&index=0&id=64ce1e52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ce1e52",
  null
  
)

export default component.exports